import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { CatenarySegmentsSwitch } from '../../interfaces/catenary-segments-switch';
import { PlotData } from '../../interfaces/plot-data';
import { ValidationError } from '../../models/catenary-answer';
import { Line } from '../../models/line.model';
import { MeshInstructions } from '../../models/mesh-instructions';

@Injectable({
  providedIn: 'root',
})
export class DataSharingService {
  public currentRoute$ = new BehaviorSubject<{
    TITLE: string;
    PATH: string;
    BREADCRUMB: string;
  }>(null);

  public localChanges$ = new BehaviorSubject<void>(null);
  public updateCatenary$ = new BehaviorSubject<void>(null);
  public updateErrorsLog$ = new Subject<ValidationError[] | void>();
  public objectSegment$ = new BehaviorSubject<CatenarySegmentsSwitch>(null);
  public pointsToPlot$ = new BehaviorSubject<PlotData>(null);
  public clearPlot$ = new Subject<void>();
  public mainChartType$ = new BehaviorSubject<string>(null);
  public selectedLineTitle$ = new BehaviorSubject<string>(null);
  public selectedLineId$ = new BehaviorSubject<number>(null);
  public validLineMesh$ = new BehaviorSubject<boolean>(true);
  public visibleChartToggler$ = new BehaviorSubject<boolean>(false);
  public meshGradient$ = new Subject<MeshInstructions>();
  public lineRegions$ = new Subject<any[]>();
  public meshPath$ = new BehaviorSubject<any>(null);
  public importedLine$ = new Subject<Line>();
  public loading$ = new BehaviorSubject<boolean>(false);
  public linesFormOverflow$ = new BehaviorSubject<boolean>(true);
}
